<template>
  <!--~~~~~     PAGE HEADER     ~~~~~-->
  <header class="page-layout__header  page-header">
    <!-- page-header__mainbar -->
    <div class="page-header__mainbar">

      <div class="page-header__inner">

        <!--<AdminSidebar/>-->

        <div class="page-header__logo">
          <div class="logo">
            <router-link class="logo__link  justify-content-center" :to="{name:'api.home'}" title="На главную">
              <svg class="logo__img">
                <use xlink:href="#logo__synak-test--full"></use>
              </svg>
            </router-link>
          </div>
        </div>

        <div class="page-header__main-nav">

          <ul class="page-header__nav-list">
            <li class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('home')}">
              <router-link class="page-header__nav-link" :to="{name:'api.home'}">
                {{ getTranslation('home') }}
              </router-link>
            </li>
            <li v-if="hasPermission('api.application.getList')" class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('application')}">
              <router-link class="page-header__nav-link" :to="{name:'api.application.getList'}">
                {{ getTranslation('applications') }}
              </router-link>
            </li>

            <li v-if="hasPermission('api.candidate.getList')" class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('candidate')}">
              <router-link class="page-header__nav-link" :to="{name:'api.candidate.getList'}">
                {{ getTranslation('candidates') }}
              </router-link>
            </li>

            <li v-if="hasPermission('api.testing.getList')" class="page-header__nav-item"
                :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('testing') && !$route.name.includes('structure') && !$route.name.includes('event') && !$route.name.includes('settings')}">
              <router-link class="page-header__nav-link" :to="{name:'api.testing.getList'}">
                {{ getTranslation('testingTypes') }}
              </router-link>
            </li>

            <li v-if="hasPermission('api.testing.structure.getList')" class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('testing.structure')}">
              <router-link class="page-header__nav-link" :to="{name:'api.testing.structure.getList'}">
                {{ getTranslation('testingStructure') }}
              </router-link>
            </li>
            <li v-if="hasPermission('api.testing.event.getList')" class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('testing.event')}">
              <router-link class="page-header__nav-link" :to="{name:'api.testing.event.getList'}">
                {{ getTranslation('events') }}
              </router-link>
            </li>
            <li v-if="hasPermission('api.report')" class="page-header__nav-item" :class="{'page-header__nav-item--current' : $route.name && $route.name.includes('api.report')}">
              <router-link class="page-header__nav-link" :to="{name:'api.report'}">
                {{ getTranslation('reports') }}
              </router-link>
            </li>
          </ul>

        </div>

        <div class="page-header__right">

          <div class="inner-page__lang test-language">
            <button class="language-button btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="lang-sm lang-lbl" :title="$lang.app[currentLocale]" :lang="currentLocale"></span>
            </button>
            <div v-if="$store.getters['language/getLocales'].length > 0" class="dropdown-menu">
              <a v-for="locale in $store.getters['language/getLocales']" @click="changeLocale(locale.title)" class="dropdown-item" href="javascript:void(0)">
                <span class="lang-sm lang-lbl" :lang="locale.title"> {{ $lang.app[locale.title] }}</span>
                <span class="sr-only">{{ locale.title }}</span>
              </a>
            </div>
          </div>

          <div class="page-header__nav">
            <ul class="page-header__nav-list">
              <li class="page-header__nav-item page-header__user-info text--bold" style="cursor: pointer">
                <div @click="userView" class="page-header__icon-wrap">
                  {{ $store.getters['user/getUser'].lname }} {{ $store.getters['user/getUser'].fname[0] || '' }}.
                </div>
              </li>
            </ul>
          </div>

          <div class="page-header__user-block">

            <ul class="page-header__nav-list">
              <li class="page-header__nav-item dropdown">
                <a ref="settingsButton" class="page-header__nav-link  js-hasDropdown skip-settings-close" href="javascript:void(0)" :title="getTranslation('settings')">
                                    <span class="page-header__icon-wrap  skip-settings-close">
          							<svg class="page-header__nav-icon  skip-settings-close">
          								<use class="skip-settings-close" xlink:href="#icon__settings"></use>
          							</svg>
          						</span>
                </a>

                <!-- SERVICES DROPDOWN -->
                <div ref="settingsContent" class="page-header__dropdown">

                  <div class="header-dropdown">

                    <div class="header-dropdown__header">
                      <h4 class="header-dropdown__title">{{ getTranslation('admin') }}</h4>
                    </div>

                    <div class="header-dropdown__body">

                      <div class="row" style="margin: 0 15px">

                        <div v-if="hasPermission('api.users.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.users.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use class="skip-settings-close" xlink:href="#icon__profile"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('users') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>

                        <div v-if="hasPermission('api.levels.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.levels.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon skip-settings-close">
                                      <use xlink:href="#icon__accesses" class="skip-services-close"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('levels') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.languages.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.languages.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon skip-settings-close">
                                      <use xlink:href="#icon__favorites" class="skip-services-close"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('languages') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.office.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.office.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__subdivisions"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('offices') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.state.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.state.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__subdivisions"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('states') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.nrk.resource.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.nrk.resource.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__departments"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body" :title="getTranslation('nrk-long')">
                                  <div class="header-dropdown-item__title">{{ getTranslation('nrk') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.attestation.resource.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.attestation.resource.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__departments"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body" :title="getTranslation('attestation')">
                                  <div class="header-dropdown-item__title">{{ getTranslation('attestation') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.mrk.resource.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.mrk.resource.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__departments"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body" :title="getTranslation('mrk')">
                                  <div class="header-dropdown-item__title">{{ getTranslation('mrk') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.testing.settings.testingTypes')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.testing.settings.testingTypes' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use class="skip-settings-close" xlink:href="#icon__settings"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('testingTypeSettings') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.mailTemplates.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.mailTemplates.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon skip-settings-close">
                                      <use xlink:href="#icon__accesses" class="skip-services-close"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('mailTemplates') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.settings.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.settings.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use class="skip-settings-close" xlink:href="#icon__settings"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('settings') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.auth.logins.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.auth.logins.getList' }">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon">
                                      <use xlink:href="#icon__favorites"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body">
                                  <div class="header-dropdown-item__title">{{ getTranslation('loginHistory') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                        <div v-if="hasPermission('api.demo.resource.getList')" class="col-md-3 p-1">
                          <div class="header-dropdown__item">
                            <router-link :to="{ name: 'api.demo.resource.getList' ,query:{pageType:'demo'}}">
                              <div class="header-dropdown-item horizontal">
                                <div class="header-dropdown-item__left">
                                  <div class="header-dropdown-item__avatar">
                                    <svg class="page-header__nav-icon  skip-settings-close">
                                      <use xlink:href="#icon__departments"></use>
                                    </svg>
                                  </div>
                                </div>

                                <div class="header-dropdown-item__body" :title="getTranslation('demo')">
                                  <div class="header-dropdown-item__title">{{ getTranslation('demo') }}</div>
                                </div>
                              </div>
                            </router-link>
                          </div>
                        </div>
                      </div>

                    </div>
                    <!-- /.header-dropdown__body -->

                  </div>
                  <!-- /.header-dropdown -->

                </div>
                <!-- / SERVICES DROPDOWN -->
              </li>

              <li class="page-header__nav-item">
                <a @click="adminLogout" href="javascript:void(0)" class="page-header__nav-link" :title="getTranslation('signOut')">
          						<span class="page-header__icon-wrap">
          							<svg class="page-header__nav-icon">
          								<use xlink:href="#icon__log-out"></use>
          							</svg>
          						</span>
                </a>
              </li>
            </ul>

          </div>

        </div>
        <!-- /page-header__right -->

      </div>
      <!-- /page-header__inner -->

    </div>
    <!-- /page-header__mainbar -->

  </header>
  <!--~~~~~     / PAGE HEADER     ~~~~~-->
</template>

<script>
import AdminSidebar from "./Sidebar";

export default {
  name: "AdminHeader",
  components: {AdminSidebar},
  mounted() {

    const settingsClose = (e) => {
      if (!e.target.classList.contains('skip-settings-close')) {
        if (this.$refs.settingsContent) {
          this.$refs.settingsContent.classList.remove('page-header__dropdown--show');
          document.removeEventListener('click', settingsClose);
        }
      }
    };

    this.$refs.settingsButton.onclick = () => {
      if (this.$refs.settingsContent) {
        this.$refs.settingsContent.classList.add('page-header__dropdown--show');
        setTimeout(() => {
          document.addEventListener('click', settingsClose);
        })
      }
    };

    const servicesClose = (e) => {
      if (!e.target.classList.contains('skip-services-close')) {
        if (this.$refs.servicesContent) {
          this.$refs.servicesContent.classList.remove('page-header__dropdown--show');
          document.removeEventListener('click', servicesClose);
        }
      }
    };

  },

  computed: {},
  methods: {
    adminLogout() {
      this.logout();
    },
    userView() {
      if (this.hasPermission('api.users.get')) {
        this.$router.push({name: 'api.users.get', params: {id: this.$store.getters['user/getUserId']}}).catch(() => {
        })
      }
    }
  }
}
</script>

<style scoped>

.header-dropdown-item.horizontal {
  max-height: 200px;
  min-height: 120px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.header-dropdown-item.horizontal .header-dropdown-item__body {
  text-align: center;
  font-size: 10px !important;
  -webkit-box-flex: unset;
  flex: unset;
  margin-top: 10px;
}

.header-dropdown-item.horizontal .header-dropdown-item__left {
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 15px;
  margin-right: 0;
}

.header-dropdown-item__title {
  margin-bottom: 2px;
  color: #2E71E5;
  font-size: 13px;
  line-height: 20px;
  font-style: normal;
  font-weight: bold;
}

.page-header__dropdown {
  z-index: 15 !important;
}

.page-header__user-info {
  display: block;
  padding: 3px 5px !important;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  color: #0080ff;
}
</style>
